import React, { useState } from "react";
import { FormFieldSet } from "../../../../../../../components";

const ByRole = ({ value=[] , onChange }) => {
  // console.log(value)
  return (
    <div className="p-2">
      <p className="text-sm text-gray-600 my-3 font-normal">
        Pick roles and users to give access to the scheduled Resume Mining
        feature.
      </p>

      <div className="flex flex-col gap-3 w-full md:w-[280px] ">
        <FormFieldSet
          type="atsRoles"
          title="By Role"
          placeholder="Select Role"
          value={value}
          onChange={onChange}
          options={[
            { label: "Research Analyst", value: 1 },
            { label: "Business Development", value: 2 },
            { label: "Recruitment", value: 3 },
            { label: "Bench Sales", value: 4 },
          ]}
          shadow
          filters={{ condition: 30 }}
          showSearch
          multiple={true}
        />
      </div>
    </div>
  );
};

export default ByRole;
